import "./App.css"
import Nav from "./components/Nav-static"
import Button from "./components/Button"
import AnimatedCursor from "react-animated-cursor"
import { useEffect, useState } from "react"
import NumberFlow, { continuous } from "@number-flow/react"
import ScrollingBanner from "./components/ScrollingbannerNew"
import Scroller from "./components/Scroller"
import ScrollerItem from "./components/ScrollerItem"
import { useInView } from "react-intersection-observer"

import { motion } from "framer-motion"

import ClientTestimonials from "./components/ClientTestimonials"
import ScrollPopup from "./components/ScrollPopup"
import InteractiveBackground from "./components/InteractiveBackground"

import { BentoGrid } from "./components/BentoGrid"
import StickyPriceBar from "./components/StickyPriceBar"
import ValueProp from "./components/ValueProp"
import MakingItBig from "./components/MakingItBig"
import WhatWeDoNew from "./components/WhatWeDoNew"
import Services from "./components/Services"
import Pricing from "./components/Pricing"
import FAQ from "./components/FAQ"
import FinalCTA from "./components/FinalCTA"
import VSLSection from "./components/VSLSection"

function App() {
	const [mobile, setMobile] = useState(false)
	const [overVideo, setOverVideo] = useState(false)

	// Stats page counter animation
	const [isInView, setIsInView] = useState(false)
	const [val1, setval1] = useState(0)
	const [val2, setval2] = useState(0)
	const [val3, setval3] = useState(0)
	const [val4, setval4] = useState(0)

	const { ref } = useInView({
		triggerOnce: true,
		threshold: 0.3,
		onChange: (inView) => {
			if (inView) {
				setIsInView(true)
			}
		},
	})

	useEffect(() => {
		if (isInView) {
			setval1(50)

			setval2(100)

			setval3(13)

			setval4(5)
		}
	}, [isInView])

	// Detect device type
	useEffect(() => {
		const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
		if (isMobile) {
			setMobile(true)
		} else {
			setMobile(false)
		}
	}, [])

	// Smooth scrolling - delayed to reduce forced reflow
	useEffect(() => {
		const initLocomotiveScroll = async () => {
			const LocomotiveScroll = (await import("locomotive-scroll")).default
			const _ls = new LocomotiveScroll()
			_ls.start()
		}
		
		// Use requestIdleCallback to defer initialization until browser is idle
		if ('requestIdleCallback' in window) {
			requestIdleCallback(() => initLocomotiveScroll(), { timeout: 2000 })
		} else {
			// Fallback for Safari
			setTimeout(() => initLocomotiveScroll(), 100)
		}
	}, [])

	return (
		<>
			
			<StickyPriceBar />
			<div className="overflow-hidden font-poppins">
				{/* Display custom cursor on desktop */}
				{!mobile ? (
					<div
						className={`${
							overVideo ? "opacity-0" : ""
						} transition-all duration-200`}
					>
						<AnimatedCursor
							innerSize={0}
							outerSize={18}
							outerAlpha={1}
							showSystemCursor={true}
							outerStyle={{
								mixBlendMode: "difference",
								background: "#FFFFFF",
								display: window.innerWidth <= 768 ? "none" : "block",
							}}
							innerScale={0}
							outerScale={4}
							trailingSpeed={7}
							clickables={[
								"a",
								'input[type="text"]',
								'input[type="file"]',
								'input[type="email"]',
								'input[type="number"]',
								'input[type="submit"]',
								'input[type="image"]',
								"label[for]",
								"select",
								"textarea",
								"button",
								".link",
							]}
						/>
					</div>
				) : (
					""
				)}

				<main className="overflow-hidden">
					{/* Landing section */}
					<div className="relative w-full h-full" id="Home">
						<InteractiveBackground />
						
						<div className="relative z-50 pointer-events-auto">
							<Nav notHomepage={false} />
						</div>
						<div className="relative z-10 min-h-svh pt-28 pb-16 sm:py-24 px-4 sm:px-8 lg:px-24 flex flex-col justify-center">
							{/* Hero Content */}
							<div className="flex flex-col items-center text-center lg:items-start lg:text-left">
								<h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-[5vw] font-semibold leading-tight max-w-[900px]">
									<span className="block">SCALING PLAYERBASES</span>
									<span className="block">
										WITH{" "}
										<motion.span 
											onClick={() => document.getElementById('Portfolio')?.scrollIntoView({ behavior: 'smooth' })}
											className="text-pink italic cursor-pointer relative inline-block"
											initial="hidden"
											whileHover="visible"
										>
											VIRAL
											<motion.svg 
												className="absolute -bottom-1 left-0 w-full h-2 text-pink pointer-events-none" 
												viewBox="0 0 100 8" 
												preserveAspectRatio="none"
											>
												<motion.path 
													d="M0 4 Q 10 1, 20 4 T 40 4 T 60 4 T 80 4 T 100 4" 
													stroke="currentColor" 
													strokeWidth="2" 
													fill="none"
													strokeLinecap="round"
													variants={{
														hidden: { pathLength: 0, opacity: 0 },
														visible: { pathLength: 1, opacity: 1 }
													}}
													transition={{ duration: 0.4, ease: "easeOut" }}
												/>
											</motion.svg>
										</motion.span>
									</span>
									<span className="block">SHORT-FORM CONTENT</span>
								</h1>

								{/* Platforms list */}
								<div className="mt-8 lg:mt-12 text-white">
									<div className="flex flex-col text-sm md:text-base lg:text-lg gap-0.5 opacity-80">
										<span>MINECRAFT • ROBLOX • FORTNITE • HYTALE • HYTOPIA</span>
										<span className="font-semibold mt-2">MARKETING AGENCY</span>
									</div>
								</div>

								{/* CTA Button */}
								<div className="mt-8 w-full max-w-[280px] z-40">
									<Button link="#Contact" theme="inverse">
										Contact Us
									</Button>
								</div>
							</div>

							{/* Controller Image - Desktop only */}
							<div
								data-scroll
								data-scroll-speed="0.5"
								className="absolute right-8 bottom-[10%] z-10 hidden lg:block"
							>
							<img
								src="gamepad-cropped.png"
								alt="Game controller"
								width={589}
								height={509}
								className="rotate-[40deg] w-[33vw] min-w-[400px] max-w-[600px]"
								draggable="false"
								fetchPriority="high"
							/>
							</div>

							{/* Controller Image - Mobile/Tablet */}
							<div className="flex justify-center mt-8 lg:hidden">
							<img
								src="gamepad-cropped.png"
								alt="Game controller"
								width={250}
								height={216}
								className="rotate-[20deg] w-[50vw] max-w-[250px]"
								draggable="false"
								fetchPriority="high"
							/>
							</div>
						</div>
					</div>

					{/* VSL Section */}
					<VSLSection 
						onMouseEnter={() => setOverVideo(true)}
						onMouseLeave={() => setOverVideo(false)}
					/>

					{/* Making It Big - Pain Points Section */}
					<MakingItBig />

					{/* What We Do - Process Steps Section */}
					<WhatWeDoNew />

					{/* Client Testimonials - Moved above Numbers & Facts */}
					<ClientTestimonials />

					{/* Numbers & Facts Section */}
					<div className="bg-dark text-white w-full 2xl:px-52 px-0 py-16 md:py-24 lg:py-32">
						<div className="lg:px-24 px-6 md:px-8">
							<div className="flex flex-col md:flex-row justify-between md:items-end gap-6 md:gap-12">
								<p className="text-base md:text-lg lg:text-xl text-muted md:w-[40%] lg:w-[30%] order-2 md:order-1">
									We've worked with many different types of games and servers since 2020.
								</p>
								<h2 className="font-semibold text-2xl sm:text-3xl md:text-4xl lg:text-5xl flex flex-col md:items-end md:text-right order-1 md:order-2">
									<span>NUMBERS</span>
									<span>& FACTS</span>
								</h2>
							</div>

							{/* Stats Grid */}
							<div className="mt-8 md:mt-12 flex flex-col md:flex-row gap-8 md:gap-12 lg:gap-16">
								{/* Logo Banner */}
								<div className="md:w-[45%]">
									<div className="flex flex-col justify-between h-full gap-4">
										<ScrollingBanner
											logoPaths={[
												"/banner/1.png",
												"/banner/2.gif",
												"/banner/3.png",
												"/banner/4.png",
												"/banner/8.webp",
												"/banner/hytopia.png",
												"/banner/rogrowth.webp",
											]}
											reverse={false}
										/>
										<ScrollingBanner
											logoPaths={[
												"/banner/5.png",
												"/banner/6.webp",
												"/banner/7.png",
												"/banner/9.png",
												"/banner/mineagepvp.png",
												"/banner/convicted.png",
											]}
											reverse={true}
										/>
									</div>
								</div>

								{/* Stats */}
								<div className="md:w-[55%]" ref={ref}>
									<div className="space-y-4 md:space-y-6">
										<div className="flex justify-between items-center py-3 border-b border-muted/30">
											<span className="text-3xl md:text-4xl lg:text-5xl font-semibold text-pink">
												<NumberFlow value={val1} plugins={[continuous]} />M+
											</span>
											<span className="text-sm md:text-base lg:text-xl text-right text-muted">Cumulative likes</span>
										</div>
										<div className="flex justify-between items-center py-3 border-b border-muted/30">
											<span className="text-3xl md:text-4xl lg:text-5xl font-semibold text-pink">
												<NumberFlow value={val2} plugins={[continuous]} />M+
											</span>
											<span className="text-sm md:text-base lg:text-xl text-right text-muted">Unique views</span>
										</div>
										<div className="flex justify-between items-center py-3 border-b border-muted/30">
											<span className="text-3xl md:text-4xl lg:text-5xl font-semibold text-pink">
												<NumberFlow value={val3} plugins={[continuous]} />+
											</span>
											<span className="text-sm md:text-base lg:text-xl text-right text-muted">Happy Clients</span>
										</div>
										<div className="flex justify-between items-center py-3">
											<span className="text-3xl md:text-4xl lg:text-5xl font-semibold text-pink">
												<NumberFlow value={val4} plugins={[continuous]} />+
											</span>
											<span className="text-sm md:text-base lg:text-xl text-right text-muted">Years of Experience</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				{/* Portfolio */}
					<div className="bg-navy text-white w-full 2xl:px-52 px-0 py-16 md:py-24 lg:py-32">
						<div className="lg:px-24 px-6 md:px-8 flex flex-col gap-6 md:gap-10">
							<h2
								className="font-semibold text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl"
								id="Portfolio"
							>
								FEATURED WORK
							</h2>

							<div className="flex flex-col gap-8 md:gap-12 lg:gap-16">
								<div className="flex flex-col gap-4">
									<p className="text-xl md:text-2xl lg:text-4xl xl:text-5xl">Minecraft</p>
									<Scroller elementWidth={300}>
										<ScrollerItem
											views="1M Views"
											channel="EndPixel"
											img="new-thumbnails/Endpixel-Thumbnail2.png"
											link="https://www.tiktok.com/@endpixelprisons/video/7374987748228222213"
										/>

										<ScrollerItem
											views="871K Views"
											channel="BigLionOG"
											img="new-thumbnails/Mineage-Thumbnail.png"
											link="https://www.tiktok.com/@biglionog/video/7283566748572388613"
										/>

										<ScrollerItem
											views="467K Views"
											channel="PvPGlobe"
											img="new-thumbnails/PvPGlobe-Thumbnail2.png"
											link="https://www.tiktok.com/@pvpglobe/video/7237645898749168902"
										/>

										<ScrollerItem
											views="375K Views"
											channel="BigLionOG"
											img="new-thumbnails/Mineage-Thumbnail2.png"
											link="https://www.tiktok.com/@biglionog/video/6949598234205539590"
										/>

										<ScrollerItem
											views="283K Views"
											channel="PvPGlobe"
											img="new-thumbnails/PvPGlobe-Thumbnail.png"
											link="https://www.tiktok.com/@pvpglobe/video/7190505478416387333"
										/>

										<ScrollerItem
											views="175K Views"
											channel="EndPixel"
											img="new-thumbnails/Endpixel-Thumbnail.png"
											link="https://www.tiktok.com/@pvpglobe/video/7237645898749168902"
										/>
									</Scroller>
								</div>

								<div className="flex flex-col gap-4">
									<p className="text-xl md:text-2xl lg:text-4xl xl:text-5xl">Roblox</p>
									<Scroller elementWidth={300}>
										<ScrollerItem
											views="593K Views"
											channel="Hunt Game"
											img="new-thumbnails/hunt2.webp"
											link="http://tiktok.com/@huntroblox/video/7476354631166201093"
										/>

										<ScrollerItem
											views="549K Views"
											channel="Gamefizz Roblox"
											img="new-thumbnails/gf1.webp"
											link="https://www.tiktok.com/@gamefizzroblox/video/7351889602585677062"
										/>

										<ScrollerItem
											views="517k Views"
											channel="Volleyball: Rivals"
											img="new-thumbnails/VolleyLegends_Thumbnail_2.webp"
											link="https://www.tiktok.com/@volleyballrivals/video/7458390192555166982"
										/>

										<ScrollerItem
											views="508K Views"
											channel="Volleyball: Rivals"
											img="new-thumbnails/VolleyLegends_Thumbnail.webp"
											link="https://www.tiktok.com/@volleyballrivals/video/7458860270023118085"
										/>

										<ScrollerItem
											views="242k Views"
											channel="Gamefizz Roblox"
											img="new-thumbnails/gf2.webp"
											link="https://www.tiktok.com/@gamefizzroblox/video/7256519521006144774"
										/>

										<ScrollerItem
											views="159K Views"
											channel="Hunt Game"
											img="new-thumbnails/hunt1.webp"
											link="https://www.tiktok.com/@huntroblox/video/7476737713111059718"
										/>
									</Scroller>
								</div>
							</div>
						</div>
				</div>

				{/* Value Prop Section */}
					<ValueProp />

					{/* Services - Why Choose Us Section */}
					<Services />

					{/* Process */}
					<div className="bg-dark text-white w-full 2xl:px-52 px-0 py-16 md:py-24 lg:py-32" id="Process">
						<BentoGrid />
					</div>

					{/* Pricing Section */}
					<Pricing />

				{/* FAQ Section */}
				<FAQ />

				{/* Final CTA Section */}
				<FinalCTA />

					{/* Footer */}
					<div className="w-full bg-white text-dark py-16 md:py-24 lg:px-24 px-6 md:px-8 2xl:px-24">
						<div className="flex flex-col sm:flex-row gap-12 sm:gap-0 items-end justify-between">
						{/* Left Column - Back to top & Navigation */}
							<div className="flex flex-col gap-8 w-full sm:w-auto items-end sm:items-start">
								<div className="sm:w-auto w-full">
									<Button link="#Home" theme="white-bg">
										Back to top
									</Button>
								</div>

								<div className="flex justify-between w-full sm:w-auto sm:block">
									{/* Navigation Links */}
									<ul className="flex flex-col items-start gap-1">
										{["About", "Portfolio", "Process", "Contact"].map((item) => (
											<li key={item}>
												<a
													href={`#${item}`}
													className="text-lg sm:text-xl md:text-2xl hover:text-pink transition-colors duration-200"
												>
													{item.toUpperCase()}
												</a>
											</li>
										))}
									</ul>

									{/* Contact Links - On mobile, appears next to nav links, right-aligned */}
									<ul className="flex flex-col items-end gap-1 sm:hidden">
										<li>
											<a
												href="mailto:contact@gamefizz.gg"
												className="text-lg hover:text-pink transition-colors duration-200"
											>
												EMAIL
											</a>
										</li>
										<li>
											<a
												href="https://discord.gg/sy5k53rkz4"
												className="text-lg hover:text-pink transition-colors duration-200"
											>
												DISCORD
											</a>
										</li>
										<li>
											<a
												href="https://x.com/GameFizzUGC"
												className="text-lg hover:text-pink transition-colors duration-200"
											>
												TWITTER
											</a>
										</li>
									</ul>
								</div>
							</div>

							{/* Middle Column - Contact Links (hidden on mobile) */}
							<ul className="hidden sm:flex flex-col items-end md:items-start gap-1">
								<li>
									<a
										href="mailto:contact@gamefizz.gg"
										className="text-lg sm:text-xl md:text-2xl hover:text-pink transition-colors duration-200"
									>
										EMAIL
									</a>
								</li>
								<li>
									<a
										href="https://discord.gg/sy5k53rkz4"
										className="text-lg sm:text-xl md:text-2xl hover:text-pink transition-colors duration-200"
									>
										DISCORD
									</a>
								</li>
								<li>
									<a
										href="https://x.com/GameFizzUGC"
										className="text-lg sm:text-xl md:text-2xl hover:text-pink transition-colors duration-200"
									>
										TWITTER
									</a>
								</li>
							</ul>

							{/* Right Column - Logo */}
							<a href="/" className="hidden sm:block">
								<div className="flex items-center gap-2 text-3xl md:text-5xl lg:text-6xl xl:text-7xl font-medium">
									<img
										className="h-10 md:h-12 lg:h-16 w-auto"
										width={64}
										height={64}
										src="/dot.png"
										alt="GameFizz logo"
									/>
									<span>Gamefizz</span>
								</div>
							</a>
						</div>

						{/* Copyright */}
						<div className="w-full flex justify-end mt-8 md:mt-12">
							<p className="text-muted text-sm">©2025 GAMEFIZZ</p>
						</div>
					</div>
				</main>
			</div>
			<ScrollPopup />
		</>
	)
}

export default App
